import { createAsyncThunk } from "@reduxjs/toolkit";
import { invalidateFreightResponse, updateSkipFreightCalculation } from "../../../checkout/shop-checkout";
import { fetchUserProfile } from "../../../user-profile/user-profile.thunks";
import { waitForUser } from "../../../../store/store";
import { getCartContext } from "../store/shop-cart.selectors";
import { StoreState } from "../../../../store/store.interface";
import { loadCustomer } from "../../../customer/customer";
import { bulkAddToCartApiCallMagento } from "../api/shop-cart.api";
import { getShopCart } from "./get-shop-cart.thunk";
import { getPromoCode } from "../../../promo-code/promo-code.selectors";
import { updatePromoCode } from "./update-promo-code.thunk";
import { getZipCode } from "../../../estimated-tax/estimated-tax.selectors";
import { getEstimatedTax } from "../../../estimated-tax/estimated-tax.thunks";
import { ActionStatus } from "../../../../common/constants/action-status";
import { getLoggedInCartQuoteIdMagento } from "./get-loggedin-cart.thunk";
import { buildSkuFromIsbn } from "../../../../common/utils/product-util";
import { BulkAddToCartThunkParam } from "../interfaces/shop-cart.interface";
import { SEG } from "../../../../common/utils/util";

export const bulkAddToCart = createAsyncThunk('shopCart/bulkAddToCart', async (bulkAddToCartThunkParam: BulkAddToCartThunkParam, thunkAPI) => {
    try {
      thunkAPI.dispatch(invalidateFreightResponse());
      thunkAPI.dispatch(updateSkipFreightCalculation(false));
      thunkAPI.dispatch(fetchUserProfile());
      await waitForUser();
      const cartContext = getCartContext(thunkAPI.getState() as StoreState);
      if (cartContext.isLoggedIn) {
        await thunkAPI.dispatch(loadCustomer());
        await thunkAPI.dispatch(getLoggedInCartQuoteIdMagento());
      }
      if (bulkAddToCartThunkParam.addItemsToMineCart) {
        bulkAddToCartThunkParam!.isbns = bulkAddToCartThunkParam!.isbns!.map(isbn => buildSkuFromIsbn(isbn, SEG));
      }
      return await bulkAddToCartApiCallMagento(thunkAPI.getState() as StoreState, bulkAddToCartThunkParam!.isbns, bulkAddToCartThunkParam!.addItemsToMineCart!);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    } finally {
      const state = thunkAPI.getState() as StoreState;
  
      thunkAPI.dispatch(getShopCart({ forceUpdate: true }));
  
      // If we have already found a promo code, update it after the quantity changes
      const promoCode = getPromoCode(state);
      if (promoCode) {
        thunkAPI.dispatch(updatePromoCode({ promoCode, forceUpdate: true }));
      }
  
      // If we have already found an estimated tax, update it after the quantity changes
      const zipCode = getZipCode(state);
      if (zipCode) {
        thunkAPI.dispatch(getEstimatedTax({ zipCode }));
      }
    }
  }, {
    condition: ((_arg, { getState }) => {
      const state = getState() as StoreState;
      return state.shopCartState.bulkAddToCart.status !== ActionStatus.loading;
    })
  });